import { defineMessages, useIntl } from 'react-intl';
import classNames from 'classnames';

import { ProductRating, PureButton } from '@jsmdg/yoshi';
import { isBox, isExperience } from '../../../shared/product-safeguards';
import { isDeliveryFormatGroup } from '../../helper/deliveryFormat';
import { useProduct } from '../../hooks/useProduct';
import { ProductDuration } from '../ProductDuration';
import { ProductLocation } from '../ProductLocation';
import { ProductParticipants } from '../ProductParticipants';
import styles from './RatingAndParticipantsContainer.module.scss';

const messages = defineMessages({
    a11yTextRating: {
        defaultMessage: '{value} Sterne von 5 aus {count} Bewertungen',
    },
});

const Rating = ({
    handleRatingClick,
}: {
    readonly handleRatingClick: () => void;
}): JSX.Element | null => {
    const intl = useIntl();
    const { rating } = useProduct();

    if (!rating || !rating.count) {
        return null;
    }

    return (
        <PureButton className="pt-1x" onClick={handleRatingClick}>
            <ProductRating
                a11yTextRating={intl.formatMessage(messages.a11yTextRating, {
                    value: rating.value,
                    count: rating.count,
                })}
                rating={rating.value}
                count={rating.count}
                className="align-items-center"
            />
        </PureButton>
    );
};

const RatingAndParticipantsContainer = ({
    handleRatingClick,
}: {
    readonly handleRatingClick: () => void;
}): JSX.Element | null => {
    const product = useProduct();

    return (
        <div className={classNames('d-flex flex-wrap mb-1x', styles.container)}>
            <Rating handleRatingClick={handleRatingClick} />
            {(isExperience(product) || isBox(product)) && (
                <div className="pt-1x">
                    <ProductParticipants
                        maxParticipants={product.maxParticipants}
                        minParticipants={product.minParticipants}
                    />
                </div>
            )}
            {isExperience(product) && !isDeliveryFormatGroup(product.productGroup) && (
                <>
                    <ProductDuration
                        activityDurationRange={product.activityDurationRange}
                        numberOfTravelNights={product.numberOfTravelNights}
                        className="pt-1x"
                    />
                    <ProductLocation locations={product.locations} className="pt-1x" />
                </>
            )}
        </div>
    );
};

export { RatingAndParticipantsContainer };
